import mutations from './eprofileAktGyogy.mutations'
import actions from './eprofileAktGyogy.actions'
import getters from './eprofileAktGyogy.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
